import { BordIlustrationIcon } from 'bord-design-system';
import CreateNewToolButton from '../CreateNewToolButton/CreateNewToolButton';
import './ToolSearchEmpty.scss';

interface IToolSearchEmpty {
  onCreateNew: () => void;
}

/**
 * Estado vacío cuando la búsqueda no arroja resultados.
 * Muestra una ilustración y la opción de crear una herramienta nueva.
 */
const ToolSearchEmpty = ({ onCreateNew }: IToolSearchEmpty) => (
  <div className="toolSearchEmpty">
    <BordIlustrationIcon variant="loupe" standardSize={48} />
    <p className="emptyTitle">No hay resultados para tu búsqueda</p>
    <p className="emptyHint">Prueba con otros términos o crea una herramienta nueva</p>
    <CreateNewToolButton onClick={onCreateNew} />
  </div>
);

export default ToolSearchEmpty;
